import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendlyComponent } from '../calendly/calendly.component';

@Component({
  selector: 'app-contact-advisor',
  templateUrl: './contact-advisor.component.html',
  styleUrls: ['./contact-advisor.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, CalendlyComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ContactAdvisorComponent implements OnInit {

  constructor() { }

  ngOnInit() {/* empty */}

}
